/* Oralux — Shopify-native interactions (ported from the original site).
   No React, no external libraries. */

(function () {
  'use strict';

  var moneyFormatCache = null;

  function moneyFormat() {
    if (!moneyFormatCache) moneyFormatCache = '${{amount}}';
    return moneyFormatCache;
  }

  function formatMoney(cents) {
    var format = moneyFormat();
    var amount = (cents / 100).toFixed(2);
    var noDecimals = amount.replace(/\.00$/, '');
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function syncPackPurchase(scope, modeOverride) {
    if (!scope) return;
    var pVariants = [];
    try { pVariants = JSON.parse(scope.getAttribute('data-variants')); } catch (e) {}
    var pPlans = {};
    try { pPlans = JSON.parse(scope.getAttribute('data-selling-plans')) || {}; } catch (e) {}
    var mode = modeOverride || scope.getAttribute('data-pack-current-mode') || 'subscribe';
    scope.setAttribute('data-pack-current-mode', mode);
    var selBtn = scope.querySelector('[data-pack-variant].selected') || scope.querySelector('[data-pack-variant]');
    var selId = selBtn ? Number(selBtn.getAttribute('data-pack-variant')) : 0;
    var match = pVariants.find(function (v) { return v.id === selId; });
    if (!match) return;

    var idIn = scope.querySelector('[data-variant-id]');
    if (idIn) idIn.value = match.id;
    var qtyIn = scope.querySelector('[data-qty-input]');
    var qtyValue = scope.querySelector('[data-qty-value]');
    if (qtyIn && !qtyIn.value) qtyIn.value = qtyValue ? qtyValue.textContent : '1';

    var plans = pPlans[String(match.id)] || [];
    var planInput = scope.querySelector('[data-selling-plan-input]');
    var freqSel = scope.querySelector('[data-pack-frequency-select]');
    if (freqSel && freqSel.options.length === 1 && plans.length) {
      freqSel.innerHTML = plans.map(function (p) { return '<option value="' + p.plan_id + '">' + p.name + ' (20% off)</option>'; }).join('');
    }
    var planId = (mode === 'subscribe' && plans.length) ? (freqSel && freqSel.value ? Number(freqSel.value) : plans[0].plan_id) : 0;
    var sealPlanId = scope.getAttribute('data-seal-selling-plan-id');
    if (mode === 'subscribe' && !planId && sealPlanId) planId = Number(sealPlanId);
    if (planInput) {
      if (planId) { planInput.value = planId; planInput.disabled = false; }
      else { planInput.value = ''; planInput.disabled = true; }
    }

    var plan = plans.find(function (p) { return p.plan_id === planId; }) || plans[0];
    var price = (mode === 'subscribe' && plan) ? plan.price : match.price;
    var priceEl = scope.querySelector('[data-product-price]');
    var cmpEl = scope.querySelector('[data-product-compare]');
    var badgeEl = scope.querySelector('[data-sale-badge]');
    if (priceEl) priceEl.textContent = formatMoney(price);
    var cmp = match.compare_at_price || 0;
    if (cmp > price) {
      if (cmpEl) { cmpEl.textContent = formatMoney(cmp); cmpEl.hidden = false; }
      if (badgeEl) { badgeEl.textContent = 'Save ' + formatMoney(cmp - price); badgeEl.hidden = false; }
    } else {
      if (cmpEl) cmpEl.hidden = true;
      if (badgeEl) badgeEl.hidden = true;
    }
    var addLbl = scope.querySelector('[data-add-label]');
    if (addLbl) addLbl.textContent = match.available ? (mode === 'subscribe' ? 'Subscribe · ' : 'Add to cart · ') + formatMoney(price) : 'Sold out';
    var addBtn = scope.querySelector('[data-add-button]');
    if (addBtn) addBtn.disabled = !match.available;
    var savEl = scope.querySelector('[data-pack-savings]');
    if (savEl) {
      if (mode === 'subscribe' && cmp > price) { savEl.textContent = "You're saving " + formatMoney(cmp - price) + ' on this order'; savEl.hidden = false; }
      else savEl.hidden = true;
    }
  }

  /* ---------- Cart ---------- */
  function cartLayer() {
    return document.querySelector('[data-oralux-cart-layer]');
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-oralux-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function openCart() {
    var layer = cartLayer();
    if (!layer) {
      window.location.href = (window.routes && routes.cart_url) || '/cart';
      return;
    }
    layer.hidden = false;
  }

  function closeCart() {
    var layer = cartLayer();
    if (layer) layer.hidden = true;
  }

  function refreshCartDrawer(cart) {
    updateCartCount(cart.item_count);
    var layer = cartLayer();
    if (!layer) return;
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart?sections=oralux-cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['oralux-cart-drawer'];
        if (!html) return;
        var wasOpen = !layer.hidden;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.cart-layer');
        if (fresh) {
          fresh.hidden = !wasOpen;
          layer.replaceWith(fresh);
        }
      })
      .catch(function () {});
  }

  function changeCartItem(key, delta) {
    var qtyEl = document.querySelector('[data-oralux-cart-change="' + key + '"]')
      ?.closest('.cart-item')
      ?.querySelector('.cart-item-controls span');
    var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 0;
    var quantity = delta === 'remove' ? 0 : Math.max(0, current + parseInt(delta, 10));
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(refreshCartDrawer)
      .catch(function () {});
  }

  document.addEventListener('click', function (event) {
    var target = event.target;

    var openBtn = target.closest('[data-oralux-cart-open]');
    if (openBtn) {
      openCart();
      return;
    }
    if (target.closest('[data-oralux-cart-close]')) {
      closeCart();
      return;
    }

    var changeBtn = target.closest('[data-oralux-cart-change]');
    if (changeBtn) {
      changeCartItem(changeBtn.getAttribute('data-oralux-cart-change'), changeBtn.getAttribute('data-delta'));
      return;
    }

    /* Mobile menu */
    var menuBtn = target.closest('[data-oralux-menu-toggle]');
    if (menuBtn) {
      var nav = document.getElementById(menuBtn.getAttribute('data-target'));
      var open = nav && nav.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    /* Homepage FAQ accordion */
    var faqBtn = target.closest('.faq-item > button');
    if (faqBtn && faqBtn.closest('[data-oralux-faq]')) {
      var item = faqBtn.parentElement;
      var list = item.parentElement;
      var wasActive = item.classList.contains('active');
      list.querySelectorAll('.faq-item').forEach(function (el) {
        el.classList.remove('active');
        var b = el.querySelector('button');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!wasActive) {
        item.classList.add('active');
        faqBtn.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    /* Shop filter tabs */
    var tab = target.closest('.pill-tabs button');
    if (tab && tab.closest('[data-oralux-shop]')) {
      var shop = tab.closest('[data-oralux-shop]');
      shop.querySelectorAll('.pill-tabs button').forEach(function (b) { b.classList.remove('active'); });
      tab.classList.add('active');
      var filter = tab.getAttribute('data-filter');
      shop.querySelectorAll('[data-shop-grid] .product-card').forEach(function (card) {
        var match = filter === 'all' || card.getAttribute('data-type') === filter;
        card.style.display = match ? '' : 'none';
      });
      return;
    }

    /* Quantity steppers */
    if (target.closest('[data-qty-minus]') || target.closest('[data-qty-plus]')) {
      var qtyWrap = target.closest('.qty');
      var valueEl = qtyWrap.querySelector('[data-qty-value]');
      var input = qtyWrap.parentElement.querySelector('[data-qty-input]');
      var v = parseInt(valueEl.textContent, 10) || 1;
      v += target.closest('[data-qty-plus]') ? 1 : -1;
      if (v < 1) v = 1;
      valueEl.textContent = v;
      if (input) input.value = v;
      return;
    }

    /* Gallery thumbs + arrows */
    var galleryScope = target.closest('[data-oralux-featured]');
    var thumbBtn = galleryScope && target.closest('[data-gallery-thumb]');
    var prevBtn = galleryScope && target.closest('[data-gallery-prev]');
    var nextBtn = galleryScope && target.closest('[data-gallery-next]');
    if (galleryScope && (thumbBtn || prevBtn || nextBtn)) {
      var main = galleryScope.querySelector('[data-gallery-main]');
      var counter = galleryScope.querySelector('[data-gallery-counter]');
      var thumbsAll = Array.prototype.slice.call(galleryScope.querySelectorAll('[data-gallery-thumb]'));
      if (!thumbsAll.length) return;

      var thumbs = thumbsAll.filter(function (t) { return !t.hidden; });
      var activeIndex = thumbs.indexOf(galleryScope.querySelector('[data-gallery-thumb].active'));
      if (activeIndex < 0) activeIndex = 0;

      var nextIndex = null;
      if (thumbBtn) {
        nextIndex = thumbs.indexOf(thumbBtn);
        if (nextIndex < 0) return;
      } else if (prevBtn) {
        nextIndex = (activeIndex - 1 + thumbs.length) % thumbs.length;
      } else if (nextBtn) {
        nextIndex = (activeIndex + 1) % thumbs.length;
      }

      if (nextIndex !== null && thumbs[nextIndex]) {
        var next = thumbs[nextIndex];
        if (main) {
          main.src = next.getAttribute('data-src');
          var alt = next.getAttribute('data-alt');
          if (alt) main.alt = alt;
          main.classList.toggle('is-lifestyle', next.getAttribute('data-kind') === 'lifestyle');
        }
        thumbs.forEach(function (t) {
          t.classList.remove('active');
          t.removeAttribute('aria-current');
        });
        next.classList.add('active');
        next.setAttribute('aria-current', 'true');
        if (counter) {
          counter.textContent = ('0' + (nextIndex + 1)).slice(-2) + ' / ' + ('0' + thumbs.length).slice(-2);
        }
      }
      return;
    }

    /* Demo variant toggle (no product selected): swap -white/-black asset sets */
    var demoVariant = target.closest('[data-demo-variant]');
    if (demoVariant) {
      var scope = demoVariant.closest('[data-oralux-featured]');
      var value = demoVariant.getAttribute('data-demo-variant');
      var other = value === 'White' ? 'Black' : 'White';
      scope.querySelectorAll('[data-demo-variant]').forEach(function (b) {
        var selected = b === demoVariant;
        b.classList.toggle('selected', selected);
        b.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      var label = scope.querySelector('[data-demo-variant-label]');
      if (label) label.textContent = value;
      scope.querySelectorAll('img').forEach(function (img) {
        img.src = img.src.replace('-' + other.toLowerCase(), '-' + value.toLowerCase());
      });
      scope.querySelectorAll('[data-src]').forEach(function (el) {
        el.setAttribute('data-src', el.getAttribute('data-src').replace('-' + other.toLowerCase(), '-' + value.toLowerCase()));
      });
      return;
    }

    /* Pack mode — subscribe & save / one-time purchase (usmile-style) */
    var packScope = target.closest('[data-pack-mode]');
    var modeBtn = target.closest('[data-pack-mode-btn]');
    var packBtn = target.closest('[data-pack-variant]');
    if (packScope && (modeBtn || packBtn)) {
      var mode = packScope.getAttribute('data-pack-current-mode') || 'subscribe';
      if (modeBtn) {
        mode = modeBtn.getAttribute('data-pack-mode-btn');
        packScope.setAttribute('data-pack-current-mode', mode);
        packScope.querySelectorAll('[data-pack-mode-btn]').forEach(function (b) {
          var on = b === modeBtn;
          b.classList.toggle('selected', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var perks = packScope.querySelector('[data-pack-perks]');
        var freq = packScope.querySelector('[data-pack-frequency]');
        if (perks) perks.hidden = mode !== 'subscribe';
        if (freq) freq.hidden = mode !== 'subscribe';
      }

      if (packBtn) {
        packScope.querySelectorAll('[data-pack-variant]').forEach(function (b) {
          var on = b === packBtn;
          b.classList.toggle('selected', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      syncPackPurchase(packScope, mode);
      return;
    }

    /* Real variant buttons */
    var optionBtn = target.closest('[data-option-value]');
    if (optionBtn) {
      var scopeEl = optionBtn.closest('[data-oralux-featured]');
      if (!scopeEl || !scopeEl.hasAttribute('data-variants')) return;
      var position = optionBtn.getAttribute('data-option-position');
      scopeEl.querySelectorAll('[data-option-position="' + position + '"]').forEach(function (b) {
        var selected = b === optionBtn;
        b.classList.toggle('selected', selected);
        b.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      var labelEl = scopeEl.querySelector('[data-option-label="' + position + '"]');
      if (labelEl) labelEl.textContent = optionBtn.getAttribute('data-option-value');

      var variants = [];
      try { variants = JSON.parse(scopeEl.getAttribute('data-variants')); } catch (e) {}
      var chosen = {};
      scopeEl.querySelectorAll('[data-option-value].selected').forEach(function (b) {
        chosen[b.getAttribute('data-option-position')] = b.getAttribute('data-option-value');
      });
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return chosen[String(i + 1)] === opt; });
      });
      if (match) {
        var idInput = scopeEl.querySelector('[data-variant-id]');
        if (idInput) idInput.value = match.id;
        var priceEls = scopeEl.querySelectorAll('[data-add-label], [data-product-price]');
        priceEls.forEach(function (el) {
          var prefix = el.hasAttribute('data-add-label') ? 'Add to cart · ' : '';
          el.textContent = match.available ? prefix + formatMoney(match.price) : 'Sold out';
        });
        var compareEl = scopeEl.querySelector('[data-product-compare]');
        var badgeEl = scopeEl.querySelector('[data-sale-badge]');
        if (match.compare_at_price && match.compare_at_price > match.price) {
          if (compareEl) { compareEl.textContent = formatMoney(match.compare_at_price); compareEl.hidden = false; }
          if (badgeEl) { badgeEl.textContent = 'Save ' + formatMoney(match.compare_at_price - match.price); badgeEl.hidden = false; }
        } else {
          if (compareEl) compareEl.hidden = true;
          if (badgeEl) badgeEl.hidden = true;
        }
        var addBtn = scopeEl.querySelector('[data-add-button]');
        if (addBtn) addBtn.disabled = !match.available;
        applyColourFilter(scopeEl);
        if (match.featured_media) {
          var thumb = scopeEl.querySelector('[data-variant-media="' + match.id + '"]');
          if (thumb) thumb.click();
        }
      }
    }
  });

  /* Show only the selected colour's images when variants carry a colour (White/Black). */
  function filterGalleryByVariant(scope, colourValue) {
    var thumbs = scope.querySelectorAll('[data-gallery-thumb]');
    if (!thumbs.length) return;
    var wanted = (colourValue || '').toLowerCase();
    var anyTagged = false;
    thumbs.forEach(function (t) { if (t.getAttribute('data-colour')) anyTagged = true; });
    if (!anyTagged) return; /* products without colour-tagged media keep the full gallery */
    var firstVisible = null;
    thumbs.forEach(function (t) {
      var c = t.getAttribute('data-colour');
      var show = !wanted || !c || c === wanted;
      t.hidden = !show;
      if (show && !firstVisible) firstVisible = t;
    });
    var active = scope.querySelector('[data-gallery-thumb].active');
    if (active && !active.hidden) return;
    var main = scope.querySelector('[data-gallery-main]');
    thumbs.forEach(function (t) { t.classList.remove('active'); t.removeAttribute('aria-current'); });
    if (firstVisible) {
      firstVisible.classList.add('active');
      firstVisible.setAttribute('aria-current', 'true');
      if (main) {
        main.src = firstVisible.getAttribute('data-src');
        var alt = firstVisible.getAttribute('data-alt');
        if (alt) main.alt = alt;
        main.classList.toggle('is-lifestyle', firstVisible.getAttribute('data-kind') === 'lifestyle');
      }
    }
  }

  function applyColourFilter(scope) {
    var colourBtn = null;
    scope.querySelectorAll('[data-option-value].selected').forEach(function (b) {
      var v = (b.getAttribute('data-option-value') || '').toLowerCase();
      if (v === 'white' || v === 'black') colourBtn = b;
    });
    filterGalleryByVariant(scope, colourBtn ? colourBtn.getAttribute('data-option-value') : '');
  }

  /* Newsletter signups: the visible Shopify `customer` form stores the subscriber
     and drives the discount redirect. Alongside it we post the same email to the
     client's MailerLite form (the one the waitlist page uses) so their welcome/
     coupon automation actually sends the email — Shopify's customer form sends
     nothing. A hidden contact form also notifies the merchant's store inbox.

     Shopify's captcha bootstrap lazily binds hCaptcha on focusin/change — hidden
     forms never get those events, so fire them at init so the token exists before
     the user submits. */
  document.querySelectorAll('form[data-signup-notify]').forEach(function (nf) {
    var f = nf.querySelector('[data-notify-email]');
    if (!f) return;
    f.dispatchEvent(new Event('focusin', { bubbles: true }));
    f.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.hasAttribute) return;
    if (form.hasAttribute('data-signup-notify') || form.hasAttribute('data-ml-signup')) return;
    if (form.__notifyDone) return;
    var scope = form.parentElement;
    var notify = scope && scope.querySelector('form[data-signup-notify]');
    var mlForm = scope && scope.querySelector('form[data-ml-signup]');
    if (!notify && !mlForm) return;
    var emailInput = form.querySelector('input[name="contact[email]"], input[type="email"]');
    if (!emailInput || !emailInput.value) return;

    event.preventDefault();
    event.stopImmediatePropagation(); /* keep Shopify's captcha bootstrap from
      natively submitting+navigating before the background posts finish */

    /* Silent MailerLite post — fires the client's welcome/coupon automation.
       The endpoint enforces reCAPTCHA per the form's MailerLite settings, so
       this only succeeds once captcha is disabled on that form; until then the
       post is harmless and the Shopify signup always proceeds. */
    var mlPending = false;
    if (mlForm) {
      var mlEmail = mlForm.querySelector('[data-ml-email]');
      if (mlEmail) mlEmail.value = emailInput.value;
      mlPending = true;
    }

    form.__notifyDone = true;
    if (notify) notify.querySelector('[data-notify-email]').value = emailInput.value;

    var pending = 0;
    var proceed = function () {
      if (pending <= 0) {
        if (form.__released) return;
        form.__released = true;
        form.requestSubmit();
      }
    };
    var track = function (iframeSel, subForm) {
      pending++;
      var iframe = scope.querySelector(iframeSel);
      if (iframe) {
        iframe.addEventListener('load', function () { pending--; proceed(); }, { once: true });
      }
      subForm.requestSubmit();
    };

    if (notify) track('iframe[name^="signup-notify-frame"]', notify);
    if (mlForm && mlPending) track('iframe[name^="ml-signup-frame"]', mlForm);
    /* fallback: never block the real signup */
    setTimeout(function () { pending = 0; proceed(); }, 4000);
    if (pending === 0) proceed();
  }, true);

  /* Add-to-cart via AJAX */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.hasAttribute('data-oralux-product-form')) return;
    event.preventDefault();
    var btn = form.querySelector('[data-add-button]');
    if (btn) btn.disabled = true;
    var packScope = form.closest('[data-pack-mode]');
    if (packScope) syncPackPurchase(packScope);
    var selectedPack = packScope && packScope.querySelector('[data-pack-variant].selected');
    var variantId = form.querySelector('[data-variant-id]').value || (selectedPack && selectedPack.getAttribute('data-pack-variant'));
    var item = {
      id: parseInt(variantId, 10),
      quantity: parseInt(form.querySelector('[data-qty-input]').value, 10) || 1
    };
    var sellingPlanInput = form.querySelector('[data-selling-plan-input]');
    if (sellingPlanInput && !sellingPlanInput.disabled && sellingPlanInput.value) {
      item.selling_plan = parseInt(sellingPlanInput.value, 10);
    }
    if (packScope) {
      item.properties = {
        _oralux_purchase_type: item.selling_plan ? 'subscribe_and_save' : 'one_time_purchase',
        _oralux_email_flow: item.selling_plan ? 'circle_save_welcome_10' : 'standard_purchase'
      };
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        refreshCartDrawer(cart);
        var label = btn && btn.querySelector('[data-add-label]');
        if (label) {
          var prev = label.textContent;
          label.textContent = 'Added to cart ✓';
          setTimeout(function () { label.textContent = prev; }, 2000);
        }
      })
      .catch(function () {})
      .finally(function () { if (btn) btn.disabled = false; });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeCart();
  });

  /* ---------- Welcome popup (10% off email capture) ---------- */
  var popup = document.querySelector('[data-oralux-popup]');
  if (popup) {
    var signedKey = 'oralux_popup_signed';
    var signed = false;
    try { signed = !!localStorage.getItem(signedKey); } catch (e) {}
    // If signup just posted successfully, show the success state immediately
    if (popup.querySelector('.popup-code')) {
      try { localStorage.setItem(signedKey, '1'); } catch (e) {}
      popup.hidden = false;
    } else if (!signed) {
      var shown = false;
      var showPopup = function () {
        if (shown) return;
        shown = true;
        popup.hidden = false;
      };
      var delay = (parseInt(popup.getAttribute('data-delay'), 10) || 15) * 1000;
      var timer = setTimeout(showPopup, delay);

      /* Exit intent — cursor leaves through the top of the page. */
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0) {
          clearTimeout(timer);
          showPopup();
        }
      });

      popup.addEventListener('click', function (e) {
        if (e.target.closest('[data-popup-close]')) popup.hidden = true;
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') popup.hidden = true;
      });
    }
  }

  // Review video sound toggle
  document.querySelectorAll('[data-video-sound]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var video = btn.closest('.review-media-wrap') && btn.closest('.review-media-wrap').querySelector('video');
      if (!video) return;
      video.muted = !video.muted;
      if (video.paused) video.play();
      btn.setAttribute('aria-pressed', String(!video.muted));
      btn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
    });
  });

  document.querySelectorAll('[data-oralux-featured]').forEach(function (scope) {
    applyColourFilter(scope);
  });

  document.querySelectorAll('[data-pack-mode]').forEach(function (scope) {
    var initMode = scope.getAttribute('data-pack-current-mode') || 'subscribe';
    var perks = scope.querySelector('[data-pack-perks]');
    var freq = scope.querySelector('[data-pack-frequency]');
    if (perks) perks.hidden = initMode !== 'subscribe';
    if (freq) freq.hidden = initMode !== 'subscribe';
    syncPackPurchase(scope);
  });

  document.addEventListener('sealsubs:selling_plan_changed', function (event) {
    var planId = event.detail && event.detail.selling_plan_id;
    if (!planId) return;
    document.querySelectorAll('[data-pack-mode]').forEach(function (scope) {
      scope.setAttribute('data-seal-selling-plan-id', planId);
      syncPackPurchase(scope, scope.getAttribute('data-pack-current-mode') || 'subscribe');
    });
  });

  document.addEventListener('sealsubs:subscription_widget_created', function () {
    document.querySelectorAll('[data-pack-mode]').forEach(function (scope) {
      syncPackPurchase(scope, scope.getAttribute('data-pack-current-mode') || 'subscribe');
    });
  });
})();

  /* Announcement slideshow */
  document.querySelectorAll('[data-announcement-rotate]').forEach(function (bar) {
    var slides = bar.querySelectorAll('[data-announcement-slide]');
    if (slides.length < 2) return;
    var idx = 0;
    setInterval(function () {
      slides[idx].classList.remove('active');
      idx = (idx + 1) % slides.length;
      slides[idx].classList.add('active');
    }, 4000);
  });
